import React from 'react';
import { Button } from './ui/Button';
import { Phone, MessageCircle, Clock, Lock, Leaf } from 'lucide-react';
export function CTASection() {
  return <section className="relative w-full py-24 px-4 overflow-hidden" data-id="element-9">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?w=1600)'
    }} data-id="element-10" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-rose-950/80 via-black/70 to-rose-950/80" data-id="element-11" />

      <div className="relative z-20 max-w-4xl mx-auto text-center text-white space-y-12" data-id="element-12">
        <h2 className="text-3xl md:text-5xl font-bold" data-id="element-13">
          📞 ATENCIÓN INMEDIATA Y CONFIDENCIAL
        </h2>

        <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-12" data-id="element-14">
          <a href="https://wa.me/13052196902" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 text-xl md:text-2xl font-bold hover:text-green-400 transition-colors" data-id="element-15">
            <MessageCircle className="w-8 h-8 text-green-500" data-id="element-16" />
            <span data-id="element-17">WhatsApp: +1 305 219 6902</span>
          </a>

          <a href="tel:+13053811985" className="flex items-center justify-center gap-3 text-xl md:text-2xl font-bold hover:text-yellow-400 transition-colors" data-id="element-18">
            <Phone className="w-8 h-8 text-yellow-500" data-id="element-19" />
            <span data-id="element-20">Llamadas: +1 305 381 1985</span>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-21">
          <div className="bg-rose-500/10 backdrop-blur-sm p-4 rounded-xl border border-rose-300/20 flex flex-col items-center gap-2" data-id="element-22">
            <Clock className="w-8 h-8 text-rose-300" data-id="element-23" />
            <span className="font-medium" data-id="element-24">Respuesta rápida</span>
          </div>
          <div className="bg-rose-500/10 backdrop-blur-sm p-4 rounded-xl border border-rose-300/20 flex flex-col items-center gap-2" data-id="element-25">
            <Lock className="w-8 h-8 text-rose-300" data-id="element-26" />
            <span className="font-medium" data-id="element-27">Confidencialidad absoluta</span>
          </div>
          <div className="bg-rose-500/10 backdrop-blur-sm p-4 rounded-xl border border-rose-300/20 flex flex-col items-center gap-2" data-id="element-28">
            <Leaf className="w-8 h-8 text-rose-300" data-id="element-29" />
            <span className="font-medium" data-id="element-30">Consulta inicial sin costo</span>
          </div>
        </div>

        <div className="space-y-8 pt-8" data-id="element-31">
          <div data-id="element-32">
            <h3 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-33">
              RESERVA TU CONSULTA AHORA
            </h3>
            <p className="text-gray-300 text-lg" data-id="element-34">
              Haz clic y recibe orientación inmediata.
            </p>
          </div>

          <a href="https://wa.me/13052196902" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto" data-id="element-35">
            <Button size="large" className="w-full sm:w-auto text-lg px-10 py-6 bg-rose-600 hover:bg-rose-700 text-white border-none font-bold shadow-[0_0_20px_rgba(225,29,72,0.5)] transition-all hover:scale-105" data-id="element-36">
              QUIERO HABLAR CON UN ESPECIALISTA
            </Button>
          </a>
        </div>
      </div>
    </section>;
}